import axios from "axios";
import { BASE_URL } from "./auth-services";

const itemServices = {};

// api for country lists
itemServices.getCountries = async (header) => {
  const { data } = await axios.get(`${BASE_URL}/Felix/CountryLists/`, header);
  return data;
};

itemServices.getRegions = async (header) => {
  const { data } = await axios.get(`${BASE_URL}/Felix/RegionLists/`, header);
  return data;
};

// api for state lists
itemServices.getStates = async (header) => {
  const { data } = await axios.get(`${BASE_URL}/Felix/StateLists/`, header);
  return data;
};

// api for city lists
itemServices.getCities = async (header) => {
  const { data } = await axios.get(`${BASE_URL}/Felix/CityLists/`, header);
  return data;
};

// api for item master
itemServices.listItemsMaster = async (page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Itemlist/?Is_Deleted=False&page=${page}`,
    header
  );
  return data;
};

// with pagination
itemServices.listItems = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Itemlist/?Is_Deleted=False`,
    header
  );
  return data;
};

itemServices.listItemsPagination = async (page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Itemlist/?page=${page}&Is_Deleted=False`,
    header
  );
  return data;
};

// without pagination
itemServices.dropdownListItems = async (id1, id2, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Itemlistwithoutpagination/?Company_Id=${id1}&Partner_Id=${id2}&Is_Deleted=False`,
    header
  );
  return data;
};

itemServices.createItems = async (inputs, header) => {
  const { data } = await axios.post(
    `${BASE_URL}/Felix/ItemCRUD/`,
    { inputs },
    header
  );
  return data;
};

itemServices.getItem = async (Id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/ItemCRUD/?Item_Id=${Id}`,
    header
  );
  return data;
};
itemServices.deleteItems = async (Id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/ItemCRUD/?Item_Id=${Id}`,
    header
  );
  return data;
};

// api for item overview page
itemServices.MaterialIssueTransaction = async (itemname, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialIssueDetailtransaction/?item_name=${itemname}`,
    header
  );
  return data;
};

itemServices.MaterialRequestTransaction = async (itemname, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialRequestDetailtransaction/?item_name=${itemname}`,
    header
  );
  return data;
};

itemServices.MaterialTransferTransaction = async (itemname, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialTransferDetailstransaction/?item_name=${itemname}`,
    header
  );
  return data;
};

itemServices.MaterialReceiptTransaction = async (itemname, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/GoodsTrfReceiptDetailstransaction/?item_name=${itemname}`,
    header
  );
  return data;
};

// api for item group
itemServices.viewItemGroup = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/ItemGroupCRUD/?id=${id}`,
    header
  );
  return data;
};

// list of item groups
itemServices.getItemGroup = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/ItemGroupAdditionalCRUD/`,
    header
  );
  return data;
};

// list of active item groups
itemServices.activeItemGroups = async (payload, header) => {
  const { data } = await axios.post(
    `${BASE_URL}/Felix/ItemGroupisactivelist/`,
    payload,
    header
  );
  return data;
};

// delete of item group
itemServices.deleteItemGroup = async (id1, id2, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/ItemGroupCRUD/?id=${id1}&Item_Id=${id2}`, //changed 20-06-2023
    header
  );
  return data;
};

// Inactive item group
itemServices.InActiveItemGroup = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/ItemGroupisactive/?id=${id}`,
    header
  );
  return data;
};

// api for view supplier
itemServices.viewSupplier = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/SupplierCRUD/?id=${id}`,
    header
  );
  return data;
};

// api for chart of account in finance module
itemServices.viewChatofAccount = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/ChartofaccountCRUD/?id=${id}`,
    header
  );
  return data;
};

itemServices.getAccountNames = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Chartofaccountmylist/?Created_By=${id}`,
    header
  );
  return data;
};

itemServices.getDropdownChartofAccount = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Partnerchartofaccount/`,
    header
  );
  return data;
};

// api for lookup table
itemServices.getLookups = async (page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Dropdwontablelist/?page=${page}`,
    header
  );
  return data;
};
itemServices.deleteLookups = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/DropdowntableCRUD/?Dropdown_Id=${id}`,
    header
  );
  return data;
};

itemServices.getUnits = async (Lookupname, header) => {
  const { data } = await axios.put(
    `${BASE_URL}/Felix/Dropdwontablesearch/`,
    Lookupname,
    header
  );
  return data;
};

// api for stores
itemServices.getStores = async (header) => {
  const { data } = await axios.get(`${BASE_URL}/Felix/Storelist/`, header);
  return data;
};

itemServices.filterStores = async (Store_City, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Storelistfilter/?Store_City=${Store_City}&Is_Deleted=False`,
    header
  );
  return data;
};
itemServices.deleteStores = async (Store_Id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/StoremasterCRUD/?Store_Id=${Store_Id}`,
    header
  );
  return data;
};

// api for costcentre
itemServices.getCostCentre = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Costcenterlist/`,
    header
  );
  return data;
};

itemServices.deleteCostCentre = async (CostCenter_Id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/CostcenterCRUD/?CostCenter_Id=${CostCenter_Id}`,
    header
  );
  return data;
};

itemServices.listMaterialReceipt = async (id1, id2, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/GoodsReceiptMyLists/?Company_Id=${id1}&Created_By=${id2}&page=${page}`,
    header
  );
  return data;
};

itemServices.getSupplier = async (header, partnerId) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Supplierlist/?Partner_Id=${partnerId}`,
    header
  );
  return data;
};

itemServices.getPoOrder = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/PODetailsCRUD/?id=${id}`,
    header
  );
  return data;
};

itemServices.searchPoOrder = async (item, header) => {
  const { data } = await axios.put(
    `${BASE_URL}/Felix/PODetailsAdditional/`,
    item,
    header
  );
  return data;
};

itemServices.deleteMaterialReceipt = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/GoodsReceiptCRUD/?id=${id}`,
    header
  );
  return data;
};


itemServices.materialreceiptlistwithoutpagination = async (id1, id2, id3, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/GoodsReceiptwithoutpagination/?Company_Id=${id1}&Created_By=${id2}&Partner_Id=${id3}`,
    header
  );
  return data;
};



// services for material request
itemServices.listMaterialRequest = async (id1, id2, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialRequestMyLists/?Company_Id=${id1}&Created_By=${id2}&Is_Deleted=false&page=${page}`,
    header
  );
  return data;
};

// list all material requests
itemServices.listAllMaterialRequest = async (id, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialRequestAdditionalCRUD/?Partner_Id=${id}&page=${page}`,
    header
  );
  return data;
};

// view material request
itemServices.viewMaterialRequest = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialRequestCRUD/?id=${id}`,
    header
  );
  return data;
};

itemServices.getDepartmentList = async (id1, id2, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/DepartmentAdditionalCRUD/?Company_Id=${id1}&Created_By=${id2}&Is_Deleted=false`,
    header
  );
  return data;
};

itemServices.getUsersList = async (header) => {
  const { data } = await axios.get(`${BASE_URL}/Felix/Userlistwithoutpagination/`, header);
  return data;
};

itemServices.deleteMaterialRequest = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/MaterialRequestCRUD/?id=${id}`,
    header
  );
  return data;
};

// partner lists
itemServices.listPartners = async (header) => {
  const { data } = await axios.get(`${BASE_URL}/Felix/PartnerListreportDropdown/`, header);
  return data;
};

itemServices.checkApprovalBasedOnWorkflow = async (name, partnerId, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/workflowfilter/?Document_Name=${name}&Partner_Id=${partnerId}`,
    header
  );
  return data;
};

// api services for material issue items
itemServices.listIssueItems = async (id1, id2, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialIssueMyLists/?Company_Id=${id1}&Created_By=${id2}&page=${page}`,
    header
  );
  return data;
};

itemServices.listAllIssueItems = async (id, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialIssueAdditionalCRUD/?Partner_Id=${id}&page=${page}`,
    header
  );
  return data;
};

itemServices.deleteMaterialIssue = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/MaterialIssueCRUD/?id=${id}`,
    header
  );
  return data;
};

// this api's are going to be use the material returns
itemServices.listMaterialReturnDatas = async (id1, id2, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialReturnMyList/?Company_Id=${id1}&Created_By=${id2}&page=${page}&Is_Deleted=false`,
    header
  );
  return data;
};

itemServices.deleteMaterialReturns = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/MaterialReturnCRUD/?id=${id}`,
    header
  );
  return data;
};

itemServices.listAllMaterialReturnDatas = async (id, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialReturnAdditionalCRUD/?Partner_Id=${id}&page=${page}`,
    header
  );
  return data;
};

// this api's are going to be use the material transfer
itemServices.listMaterialTransferDatas = async (id1, id2, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialTransferMyList/?Company_Id=${id1}&Created_By=${id2}&page=${page}&Is_Deleted=false`,
    header
  );
  return data;
};

itemServices.listAllMaterialTransferDatas = async (id, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/MaterialTransferAdditionalCRUD/?Partner_Id=${id}&page=${page}&Is_Deleted=false`,
    header
  );
  return data;
};

itemServices.deleteMaterialTransfers = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/MaterialTransferCRUD/?id=${id}`,
    header
  );
  return data;
};

// this api's are going to be use the store adjustment
itemServices.listMaterialStoreAdjustmentDatas = async (id1, id2, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/StoreAdjustmentMyList/?Company_Id=${id1}&Created_By=${id2}&Is_Deleted=False&page=${page}`,
    header
  );
  return data;
};

itemServices.listAllStoreAdjustmentDatas = async (id, page, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/StoreAdjustmentAdditional/?Partner_Id=${id}&Is_Deleted=False&page=${page}`,
    header
  );
  return data;
};

itemServices.deleteStoresAdjustment = async (id, header) => {
  const { data } = await axios.delete(
    `${BASE_URL}/Felix/StoreAdjustmentCRUD/?id=${id}`,
    header
  );
  return data;
};

// api for document approvals
itemServices.getEmployees = async (email, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/getemployeeeid/?email=${email}`,
    header
  );
  return data;
};

itemServices.filterDocumentApprovalUsingRequestId = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Materialrequestworkflow/?Request_Id=${id}`,
    header
  );
  return data;
};

itemServices.filterDocumentApprovalUsingRequestIdForPurchase = async (id, header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Purchaserequestworkflow/?Request_Id=${id}`,
    header
  );
  return data;
};


// add prince
itemServices.getBusinessUnitList = async (header) => {
  const { data } = await axios.get(
    `${BASE_URL}/Felix/Businessunitlistwithoutpage/`,
    header
  );
  return data;
};

export default itemServices;
